import { render, staticRenderFns } from "./confirm-scores.vue?vue&type=template&id=3dfd1800&scoped=true"
import script from "./confirm-scores.vue?vue&type=script&lang=js"
export * from "./confirm-scores.vue?vue&type=script&lang=js"
import style0 from "./confirm-scores.vue?vue&type=style&index=0&id=3dfd1800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd1800",
  null
  
)

export default component.exports